import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const EmailVerify = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Check className="w-8 h-8 text-green-600" />
        </div>
        <h1 className="text-2xl font-chivo font-bold text-slate-900 mb-2">Email Verified</h1>
        <p className="text-slate-600 mb-6">
          Your email {user.email} has been successfully verified.
        </p>
        <Button
          data-testid="back-to-dashboard-btn"
          onClick={() => navigate(user.role === 'buyer' ? '/buyer/dashboard' : '/seller/dashboard')}
        >
          Back to Dashboard
        </Button>
      </Card>
    </div>
  );
};

export default EmailVerify;
